import Vue from 'vue';
import Router from 'vue-router';
import {httpClient} from "@/utils/request";

Vue.use(Router);


const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/index/index.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/about/about.vue'),
    },
    {
        path: '/companyDetail',
        name: 'companyDetail',
        component: () => import('../views/about/companyDetail.vue'),
    },
    {
        path: '/groupDetail',
        name: 'groupDetail',
        component: () => import('../views/index/groupDetail.vue'),
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/news/news.vue'),
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('../views/news/newsDetail.vue'),
    },
    {
        path: '/groupIndustry',
        name: 'groupIndustry',
        component: () => import('../views/groupIndustry/groupIndustry.vue'),
    },
    {
        path: '/groupIndustryDetail',
        name: 'groupIndustryDetail',
        component: () => import('../views/groupIndustry/groupIndustryDetail.vue'),
    },
    {
        path: '/information',
        name: 'information',

        component: () => import('../views/information/information.vue'),
    },
    {
        path: '/informationDetail',
        name: 'informationDetail',

        component: () => import('../views/information/informationDetail.vue'),
    },
    {
        path: '/contact',
        name: 'contact',

        component: () => import('../views/contact/contact.vue'),
    },
    {
        path: '/forRentDetail',
        name: 'forRentDetail',

        component: () => import('../views/contact/forRentDetail.vue'),
    },
    {
        path: '/publicDetail',
        name: 'publicDetail',

        component: () => import('../views/publicDetail/publicDetail.vue'),
    },
    {
        // 404 页面路由（必须放在最后）
        path: '*',
        name: 'NotFound',
        redirect: '/'
    }
];
const getConfig = () => {
    httpClient.get(this, {
        url: 'web/getConfig',
        data: { pageType: 100 },
        success(me, data) {
            localStorage.setItem('SendiConfig', JSON.stringify(data))
        }
    })
}
getConfig()

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({routes,  mode: 'history'});

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    next();
});

export {
    router
};

